/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { LIST_SUPPORT_MATERIAL_TYPES } from "./actionTypes"
import { apiError, listSupportMaterialTypesSuccess } from "./actions"

//Include Both Helper File with needed methods
import { getSupportMaterialTypes } from "../../../helpers/backend_helper"

function* get(action) {
  try {
    const response = yield call(getSupportMaterialTypes, action.payload.idCurso)
    yield put(listSupportMaterialTypesSuccess(response))
  } catch (error) {
    yield put(apiError(error))
  }
}

function* supportMaterialTypesListSaga() {
  yield takeEvery(LIST_SUPPORT_MATERIAL_TYPES, get)
}

export default supportMaterialTypesListSaga
